import { EntityId } from "@jackfruit/common"
import React from "react"
import { useLineItem } from "~/hooks/useLineItem"
import ImageRegionPreview from "../../common/ImageRegionPreview"
import { useFrameImageForPage } from "../hooks/useFrameImageForPage"
import { usePhotoBookPages } from "../hooks/usePhotoBookPages"

interface Props {
  lineItemId: EntityId
}

const PhotoBookFrontCoverRenderer: React.FC<Props> = ({ lineItemId }) => {
  const { product } = useLineItem(lineItemId)
  const { frontCoverPage, insidePages } = usePhotoBookPages(lineItemId)
  const firstInsidePage = insidePages[0]

  const { productImage: coverProductImage } = useFrameImageForPage(
    lineItemId,
    frontCoverPage!.id
  )
  const { productImage: firstInsidePageProductImage } = useFrameImageForPage(
    lineItemId,
    firstInsidePage!.id
  )

  const { seeThrough, imageRegionIds: coverImageRegionIds = [] } =
    frontCoverPage!
  const hasCustomCover = coverImageRegionIds.length > 0

  const coverFrameWidth = coverProductImage!.metaData.frame?.width ?? 0
  const coverFrameHeight = coverProductImage!.metaData.frame?.height ?? 0

  const firstInsidePageWindowX =
    firstInsidePageProductImage?.metaData.frame?.window?.x
  const firstInsidePageWindowY =
    firstInsidePageProductImage?.metaData.frame?.window?.y
  const firstInsidePageWindowWidth =
    firstInsidePageProductImage?.metaData.frame?.window?.width
  const firstInsidePageWindowHeight =
    firstInsidePageProductImage?.metaData.frame?.window?.height

  const productWidth = product.pixelWidth
  const productHeight = product.pixelHeight

  const { imageRegionIds = [] } = firstInsidePage!

  return (
    <svg viewBox={`0 0 ${coverFrameWidth} ${coverFrameHeight}`}>
      {seeThrough && (
        <svg
          x={firstInsidePageWindowX}
          y={firstInsidePageWindowY}
          width={firstInsidePageWindowWidth}
          height={firstInsidePageWindowHeight}
          viewBox={`0 0 ${firstInsidePage?.width} ${firstInsidePage?.height}`}
        >
          {imageRegionIds.map(imageRegionId => {
            return (
              <ImageRegionPreview
                key={imageRegionId}
                imageRegionId={imageRegionId}
                isRealTime={false}
              />
            )
          })}
        </svg>
      )}
      {hasCustomCover && (
        <svg
          x={firstInsidePageWindowX}
          y={firstInsidePageWindowY}
          width={firstInsidePageWindowWidth}
          height={firstInsidePageWindowHeight}
          viewBox={`0 0 ${productWidth} ${productHeight}`}
        >
          {coverImageRegionIds.map(imageRegionId => {
            return (
              <ImageRegionPreview
                key={imageRegionId}
                imageRegionId={imageRegionId}
                isRealTime={false}
              />
            )
          })}
        </svg>
      )}
      <image
        x={0}
        y={0}
        width={coverFrameWidth}
        height={coverFrameHeight}
        xlinkHref={coverProductImage!.thumbnail}
        pointerEvents="none"
      />
    </svg>
  )
}

export default PhotoBookFrontCoverRenderer
